"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownAuthenticationDomain = exports.AuthenticatedDomain = exports.UnauthenticatedDomain = void 0;
// Remove all class definitions and only export from the new files
var UnauthenticatedDomain_1 = require("./UnauthenticatedDomain");
Object.defineProperty(exports, "UnauthenticatedDomain", { enumerable: true, get: function () { return UnauthenticatedDomain_1.UnauthenticatedDomain; } });
var AuthenticatedDomain_1 = require("./AuthenticatedDomain");
Object.defineProperty(exports, "AuthenticatedDomain", { enumerable: true, get: function () { return AuthenticatedDomain_1.AuthenticatedDomain; } });
var UnknownAuthenticationDomain_1 = require("./UnknownAuthenticationDomain");
Object.defineProperty(exports, "UnknownAuthenticationDomain", { enumerable: true, get: function () { return UnknownAuthenticationDomain_1.UnknownAuthenticationDomain; } });
